import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const IndividualJourneyAnalyticsMainContainer = lazy(
  () =>
    import(
      "../components/IndividualJourneyAnalyticsMainContainer/IndividualJourneyAnalyticsMainContainer"
    )
);

const IndividualJourneyAnalyticsRoutes: RouteObject = {
  path: "journeys/:id/analytics",
  element: <IndividualJourneyAnalyticsMainContainer />,
};

export default IndividualJourneyAnalyticsRoutes;
